/**
 * Created by Amit.
 */
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {BonusBunniesGameConfig} from "./BonusBunniesGameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BonusBunniesSoundConfig} from "./BonusBunniesSoundConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {BonusBunniesFontConfig} from "./BonusBunniesFontConfig";
import {BonusBunniesGameAssets} from "./BonusBunniesGameAssets";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {BonusBunniesServerDataParser} from "./server/BonusBunniesServerDataParser";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {BonusBunniesParsedInitData} from "./server/data/BonusBunniesParsedInitData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {BonusBunniesParsedGameData} from "./server/data/BonusBunniesParsedGameData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {BonusGameZeroBet} from "./zerobet/BonusGameZeroBet";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BasicStateReelSymbol} from "./symbols/BasicStateReelSymbol";
import {BonusBunniesLogo} from "./logo/BonusBunniesLogo";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {WildExpansionController} from "./winpresentation/wildexpansion/WildExpansionController";
import {BonusBunniesBigWinController} from "./winpresentation/bigwin/BonusBunniesBigWinController";
import {BonusBunniesInitialWPController} from "./winpresentation/initial/BonusBunniesInitialWPController";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {BonusBunniesFreeSpinIntroController} from "./screens/freespinintro/BonusBunniesFreeSpinIntroController";
import {BonusBunniesFreeSpinIntroView} from "./screens/freespinintro/BonusBunniesFreeSpinIntroView";
import {BonusBunniesFreeSpinOutroController} from "./screens/freespinoutro/BonusBunniesFreeSpinOutroController";
import {BonusBunniesFreeSpinOutroView} from "./screens/freespinoutro/BonusBunniesFreeSpinOutroView";
import {BonusBunniesBackground} from "./background/BonusBunniesBackground";
import {BonusBunniesStickyBonusWPController} from "./winpresentation/stickybonusvalues/BonusBunniesStickyBonusWPController";
import {BonusBunniesStickyBonusWPView} from "./winpresentation/stickybonusvalues/BonusBunniesStickyBonusWPView";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {BonusBunniesSpinController} from "./spin/BonusBunniesSpinController";
import {BonusBunniesBottomRowWPController} from "./winpresentation/extrarow/BonusBunniesBottomRowWPController";
import {BonusBunniesExtraReelWPController} from "./winpresentation/extrareel/BonusBunniesExtraReelWPController";
import {BonusBunniesBonusMultiplierWPController} from "./winpresentation/bonusmultiplier/BonusBunniesBonusMultiplierWPController";
import {BonusBunniesBonusMultiplierWPView} from "./winpresentation/bonusmultiplier/BonusBunniesBonusMultiplierWPView";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesReelController} from "./reel/BonusBunniesReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {BonusBunniesReelAreaView} from "./reel/BonusBunniesReelAreaView";
import {BonusBunniesHarvesterWinView} from "./bonuswin/harvester/BonusBunniesHarvesterWinView";
import {BonusBunniesHarvesterWinController} from "./bonuswin/harvester/BonusBunniesHarvesterWinController";
import {BonusBunniesFertilizerWinController} from "./bonuswin/fertilizer/BonusBunniesFertilizerWinController";
import {BonusBunniesFertilizerWinView} from "./bonuswin/fertilizer/BonusBunniesFertilizerWinView";
import {BonusBunniesB5WinView} from "./bonuswin/b5/BonusBunniesB5WinView";
import {BonusBunniesB5NearWinView} from "./reelstoppresentation/b5nearwin/BonusBunniesB5NearWinView";
import {BonusBunniesBonusSpinsCounterView} from "./bonusspinscounter/BonusBunniesBonusSpinsCounterView";
import {BonusBunniesBonusSpinsCounterController} from "./bonusspinscounter/BonusBunniesBonusSpinsCounterController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {BonusBunniesValueSymbolReplacerController} from "./reelstoppresentation/valuesymbolreplacer/BonusBunniesValueSymbolReplacerController";
import {BonusBunniesBonusWildAttentionController} from "./reelstoppresentation/bonuswildattention/BonusBunniesBonusWildAttentionController";
import {BonusBunniesSpinReelPartAnimator} from "./reel/BonusBunniesSpinReelPartAnimator";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {BonusBunniesInitialWPView} from "./winpresentation/initial/BonusBunniesInitialWPView";
import {BonusBunniesIndividualWPController} from "./winpresentation/individual/BonusBunniesIndividualWPController";
import {BonusBunniesBetlineView} from "./betline/BonusBunniesBetlineView";
import {BonusBunniesBetlineNumber} from "./betline/BonusBunniesBetlineNumber";
import {BonusBunniesBetline} from "./betline/BonusBunniesBetline";
import {BonusBunniesLayerController} from "./layercontroller/BonusBunniesLayerController";
import {BonusBunniesValueSymbolReplacerView} from "./reelstoppresentation/valuesymbolreplacer/BonusBunniesValueSymbolReplacerView";
import {BonusBunniesB5NearWinController} from "./reelstoppresentation/b5nearwin/BonusBunniesB5NearWinController";
import {BonusBunniesBaseGameNearWinController} from "./reelstoppresentation/basegamenearwin/BonusBunniesBaseGameNearWinController";
import {BonusBunniesZeppelinController} from "./zeppelin/BonusBunniesZeppelinController";
import {BonusBunniesBonusGameInfoPlate} from "./bonusgameinfoplate/BonusBunniesBonusGameInfoPlate";
import {BonusBunniesBonusSpinsChestController} from "./bonusspinschest/BonusBunniesBonusSpinsChestController";
import {BonusBunniesBonusFillUpMeterWPController} from "./winpresentation/bonusmeter/BonusBunniesBonusFillUpMeterWPController";
import {BonusBunniesSpinSoundsController} from "./spinsounds/BonusBunniesSpinSoundsController";
import {BonusBunniesBonusSymbolB2B3WPController} from "./winpresentation/bonussymbolB2B3win/BonusBunniesBonusSymbolB2B3WPController";
import {BonusBunniesBonusSymbolB5WPController} from "./winpresentation/bonussymbolB5win/BonusBunniesBonusSymbolB5WPController";
import {BonusBunniesBonusGameNearWinUntilWinController} from "./reelstoppresentation/bonusnearwinuntilwin/BonusBunniesBonusGameNearWinUntilWinController";
import {FeaturePrice} from "./server/FeaturePrice";


export class BonusBunniesGameModuleConfig implements IGameModuleConfig {
    private static gameTweakerTest:GameTweakerTest;
    public static background:BonusBunniesBackground;
    public static bonusBunniesSpinController:BonusBunniesSpinController;
    public static bonusBunniesReelAreaView:BonusBunniesReelAreaView;
    public static bonusBunniesStickyBonusWPView:BonusBunniesStickyBonusWPView;
    public static bonusBunniesBonusMultiplierWPView:BonusBunniesBonusMultiplierWPView;
    public static bonusBunniesHarvesterWinView:BonusBunniesHarvesterWinView;
    public static bonusBunniesStickyBonusWPController:BonusBunniesStickyBonusWPController;
    private static bonusBunniesHarvesterWinController:BonusBunniesHarvesterWinController;
    private static bonusBunniesFertilizerWinController:BonusBunniesFertilizerWinController;
    public static bonusBunniesFertilizerWinView:BonusBunniesFertilizerWinView;
    public static bonusBunniesB5WinView:BonusBunniesB5WinView;
    public static bonusBunniesB5NearWinView:BonusBunniesB5NearWinView;
    public static bonusBunniesBonusSpinsCounterView:BonusBunniesBonusSpinsCounterView;
    public static bonusBunniesBonusWildAttentionController:BonusBunniesBonusWildAttentionController;
    public static bonusBunniesInitialWPView:BonusBunniesInitialWPView;
    public static bonusBunniesLayerController:BonusBunniesLayerController;
    public static bonusBunniesValueSymbolReplacerView:BonusBunniesValueSymbolReplacerView;
    public static bonusBunniesBottomRowWPController:BonusBunniesBottomRowWPController;
    public static bonusBunniesExtraReelWPController:BonusBunniesExtraReelWPController;
    public static bonusBunniesBonusSpinsCounterController:BonusBunniesBonusSpinsCounterController;
    public static bonusBunniesZeppelinController:BonusBunniesZeppelinController;
    public static bonusBunniesBonusGameInfoPlate:BonusBunniesBonusGameInfoPlate;
    public static bonusBunniesBonusSpinsChestController:BonusBunniesBonusSpinsChestController;
    public static bonusBunniesBonusMultiplierWPController:BonusBunniesBonusMultiplierWPController;
    public static bonusBunniesBigWinController:BonusBunniesBigWinController;
    public static bonusBunniesInitialWPController:BonusBunniesInitialWPController;
    public static featurePrice:FeaturePrice;

    private static logo:BonusBunniesLogo;
    public static instance:BonusBunniesGameModuleConfig = new BonusBunniesGameModuleConfig();
    GAME_CONFIG:IGameConfig = BonusBunniesGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = BonusBunniesSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = BonusBunniesFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = BonusBunniesGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new BonusBunniesServerDataParser();

    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData =
        (data, dataParser:ServerDataParser) => new BonusBunniesParsedInitData(data, <BonusBunniesServerDataParser>dataParser);

    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData =
        (data, dataParser:ServerDataParser) => new BonusBunniesParsedGameData(data, <BonusBunniesServerDataParser>dataParser);

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return BonusBunniesGameModuleConfig.bonusBunniesReelAreaView = new BonusBunniesReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => {
        return new BonusBunniesReelController(reelId);
    };

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    REEL_PART_ANIMATOR:(reelId:number) => SpinReelPartAnimator = reelId => {
        return new BonusBunniesSpinReelPartAnimator(reelId);
    };

    SPIN_CONTROLLER:() => SpinController = () => {
        return BonusBunniesGameModuleConfig.bonusBunniesSpinController = new BonusBunniesSpinController();
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig):BasicStateReelSymbol => {
                return new BasicStateReelSymbol(symName, reelId, state);
            });
    };

    SCREENS:(() => ScreenController)[] = [
        () => {
            return new BonusBunniesFreeSpinIntroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new BonusBunniesFreeSpinIntroView({
                        layer : BonusBunniesGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        }
                    }, false);
                }
            });
        },
        () => {
            return new BonusBunniesFreeSpinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new BonusBunniesFreeSpinOutroView({
                        layer : BonusBunniesGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        }
                    }, false);
                }
            });
        }
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => {
            return new BonusGameZeroBet();
        },
        () => {
            return new FreespinZeroBetController();
        },
    ];


    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPController = new BonusBunniesStickyBonusWPController(indexes)],
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesBottomRowWPController = new BonusBunniesBottomRowWPController(indexes)],
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesExtraReelWPController = new BonusBunniesExtraReelWPController(indexes)],
        [indexes => new BonusBunniesBonusSymbolB2B3WPController(indexes)],
        [indexes => new BonusBunniesBonusSymbolB5WPController(indexes)],
        [indexes => new WildExpansionController(indexes)],
        [indexes => new BonusBunniesBonusFillUpMeterWPController(indexes)],
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPController = new BonusBunniesBonusMultiplierWPController(indexes)],
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesInitialWPController = new BonusBunniesInitialWPController(indexes)],
        [indexes => BonusBunniesGameModuleConfig.bonusBunniesBigWinController = new BonusBunniesBigWinController(indexes)],
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => {
            return new BonusBunniesValueSymbolReplacerController(index);
        },
        (index:number) => {
            return BonusBunniesGameModuleConfig.bonusBunniesBonusWildAttentionController = new BonusBunniesBonusWildAttentionController(index);
        },
        (index:number) => {
            return new BonusBunniesB5NearWinController(index);
        },
        (index:number) => {
            return new BonusBunniesBonusGameNearWinUntilWinController(index);
        },
        (index:number) => {
            return new BonusBunniesBaseGameNearWinController(index);
        }
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new BonusBunniesIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        BonusBunniesGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        BonusBunniesGameModuleConfig.logo = new BonusBunniesLogo();
        BonusBunniesGameModuleConfig.bonusBunniesHarvesterWinController = new BonusBunniesHarvesterWinController();
        BonusBunniesGameModuleConfig.bonusBunniesFertilizerWinController = new BonusBunniesFertilizerWinController();
        BonusBunniesGameModuleConfig.bonusBunniesB5WinView = new BonusBunniesB5WinView();
        BonusBunniesGameModuleConfig.bonusBunniesLayerController = new BonusBunniesLayerController();
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterController = new BonusBunniesBonusSpinsCounterController();
        BonusBunniesGameModuleConfig.bonusBunniesZeppelinController = new BonusBunniesZeppelinController();
        BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate = new BonusBunniesBonusGameInfoPlate();
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController = new BonusBunniesBonusSpinsChestController();
        const bonusBunniesSpinSoundsController:BonusBunniesSpinSoundsController = new BonusBunniesSpinSoundsController();

        BonusBunniesGameModuleConfig.background = new BonusBunniesBackground({
            layer : BonusBunniesGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : BonusBunniesGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : BonusBunniesGameAssets.BONUS_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                BONUS_GAME : {image : BonusBunniesGameAssets.BONUS_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)}
            },
            stretch : false
        });

        const betLinesView:BonusBunniesBetlineView = new BonusBunniesBetlineView(
            {
                map : [1, 5, 14, 2, 6, 8, 11, 15, 3, 7, 9, 12, 4, 10, 13,// left
                    20, 22, 23, 21, 24, 26, 29, 16, 17, 25, 27, 30, 18, 19, 28 // right
                ],
            },
            (index:number):BonusBunniesBetlineNumber => {
                return new BonusBunniesBetlineNumber(index, {
                    layer : "",
                    width : 0,
                    height : 0,
                    horizontalPadding : 0,
                    verticalPadding : 0,
                    textStyleNormal : {}
                });
            },
            (index:number, numberPosition:number[], betLineData:number[]):BonusBunniesBetline => {
                return new BonusBunniesBetline(index, numberPosition, betLineData, {
                    staticLineLayer : "",
                    styles : [],
                    numberOffsetX : 0,
                    pointOverlapVerticalOffset : 0
                });
            });

        BonusBunniesGameModuleConfig.featurePrice = new FeaturePrice();
    };

    constructor() {
        if(BonusBunniesGameModuleConfig.instance) {
            throw new Error("BonusBunniesGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}